import * as React from 'react';
import { Subtract } from 'utility-types';
import { ServiceLocator } from '../../app/ServiceLocator';

import { IReactTranslateService } from '../../common/react/IReactTranslateService';
import { IScheduleFrequencyDescriptionFilter } from '../../ts/filters/ScheduleFrequencyDescriptionFilter';
import { FlowPlace } from '../../ts/models/FlowPlace';
import { IPlace } from '../../ts/models/IPlace';
import { PublishFlowAction } from '../../ts/services/PublishFlowAction';

export interface InjectedFlowSpaceServiceInjectorProps {
  readonly place: IPlace;
  readonly publishFlowAction: PublishFlowAction;
  readonly sanitizer: ng.sanitize.ISanitizeService;
  readonly scheduleFrequencyDescriptionFilter: IScheduleFrequencyDescriptionFilter;
  readonly translate: IReactTranslateService;
}

export interface FlowSpaceServiceInjectorProps {
  readonly flowId: string;
}

export function withFlowSpaceServiceInjector<P extends InjectedFlowSpaceServiceInjectorProps>(
  Component: React.ComponentType<P>
) {
  return function FlowSpaceServiceInjector(
    props: Subtract<P, InjectedFlowSpaceServiceInjectorProps> & FlowSpaceServiceInjectorProps
  ) {
    const $filter = ServiceLocator.get<ng.IFilterService>('$filter');
    const $sanitize = ServiceLocator.get<ng.sanitize.ISanitizeService>('$sanitize');
    const $translate = ServiceLocator.get<ng.translate.ITranslateService>('$translate');
    const flowPlace = ServiceLocator.get<FlowPlace>('FlowPlace');
    const publishFlowAction = ServiceLocator.get<PublishFlowAction>('PublishFlowAction');

    return <Component
      {...props as unknown as P}
      place={flowPlace.create(props.flowId)}
      publishFlowAction={publishFlowAction}
      sanitizer={$sanitize}
      scheduleFrequencyDescriptionFilter={$filter('scheduleFrequencyDescription')}
      translate={$translate.instant.bind($translate)}
    />;
  };
}
